import styled from 'styled-components'

import { variables } from '../../Styled/variables'

export const Container = styled.div`
  background: ${({ theme }) => theme.color.white};
  border: 1px solid ${({ theme }) => theme.color.lightGrey};
  border-radius: 16px;
  padding: 24px;
  box-shadow: ${({ theme }) => theme.shadow.card};
  max-width: 1120px;
  min-width: 288px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Title = styled.p`
  font-family: 'Segoe UI', sans-serif;
  font-weight: ${variables.fontWeight600};
  font-size: ${variables.fontSize18};
  line-height: ${variables.lineHeight150per};
  color: ${({ theme }) => theme.color.darkGrey};
  margin: 0;
  width: 100%;
`

export const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`

export const ItemCard = styled.div<{ $isSelected?: boolean }>`
  background: ${({ theme }) => theme.color.white};
  color: ${({ theme }) => theme.color.darkGrey};
  border: 1px solid
    ${({ $isSelected, theme }) =>
      $isSelected ? theme.color.brandGreen : theme.color.lightGrey};
  border-radius: 16px;
  padding: 24px;
  display: flex;
  gap: 16px;
  align-items: center;
  max-width: 1120px;
  cursor: pointer;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: ${({ $isSelected, theme }) =>
      $isSelected ? theme.color.brandGreen : theme.color.mediumGrey};
  }
`

export const ItemContent = styled.div`
  display: flex;
  gap: 8px;
  flex: 1;
  min-width: 0;
`

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
`

export const HeadlineWrapper = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
  width: 100%;
`

export const ItemTitle = styled.p`
  font-family: 'Segoe UI', sans-serif;
  font-weight: ${variables.fontWeight600};
  font-size: ${variables.fontSize16};
  line-height: ${variables.lineHeight150per};
  color: ${({ theme }) => theme.color.darkGrey};
  margin: 0;
  white-space: nowrap;
`

export const ItemDescription = styled.p`
  font-family: 'Segoe UI', sans-serif;
  font-weight: ${variables.fontWeight400};
  font-size: ${variables.fontSize14};
  line-height: ${variables.lineHeight150per};
  color: ${({ theme }) => theme.color.darkGrey};
  margin: 0;
  width: 100%;
  padding-left: 20px;
`

export const NewLabel = styled.div`
  background: ${({ theme }) => theme.color.lightGreen};
  border-radius: 16px;
  padding: 0 6px;
  height: 24px;
  display: flex;
  align-items: center;
  font-family: 'Segoe UI', sans-serif;
  font-weight: ${variables.fontWeight400};
  font-size: ${variables.fontSize12};
  line-height: ${variables.lineHeight150per};
  color: ${({ theme }) => theme.color.darkGreen};
  white-space: nowrap;
`
